import { echo, configureEcho } from '@laravel/echo-vue'

import Pusher from 'pusher-js'
window.Pusher = Pusher

// Helper function to get current token based on path
const getCurrentToken = () => {
  const path = window.location.pathname
  if (path.startsWith('/retailer')) {
    return localStorage.getItem('retailer_access_token')
  } else if (path.startsWith('/admin')) {
    return localStorage.getItem('user_access_token')
  }
  return ''
}

// Echo instance yönetimi için utility fonksiyonlar
export const EchoManager = {
  initialize() {
    if (!this.isInitialized()) {
      configureEcho({
        broadcaster: 'reverb',
        key: import.meta.env.VITE_REVERB_APP_KEY,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: import.meta.env.VITE_REVERB_PORT,
        wssPort: import.meta.env.VITE_REVERB_PORT,
        forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
        authEndpoint: import.meta.env.VITE_BROADCASTING_URL,
        auth: {
          headers: {
            Authorization: 'Bearer ' + getCurrentToken()
          }
        }
      })
    }
  },

  isInitialized() {
    try {
      const echoInstance = echo()
      return !!echoInstance
    } catch {
      return false
    }
  },

  updateToken(newToken) {
    try {
      const echoInstance = echo()

      if (echoInstance && echoInstance.connector && echoInstance.connector.options) {
        echoInstance.connector.options.auth.headers.Authorization = 'Bearer ' + newToken

        if (echoInstance.connector.socket) {
          echoInstance.disconnect()

          setTimeout(() => {
            try {
              echoInstance.connect()
            } catch (error) {
              this.reconfigure(newToken)
            }
          }, 100)
        }

        return true
      }
    } catch (error) {
      return false
    }

    return this.reconfigure(newToken)
  },

  // Token değişikliğinde yeni instance oluştur (fallback)
  reconfigure(newToken) {
    try {
      configureEcho({
        broadcaster: 'reverb',
        key: import.meta.env.VITE_REVERB_APP_KEY,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: import.meta.env.VITE_REVERB_PORT,
        wssPort: import.meta.env.VITE_REVERB_PORT,
        forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
        authEndpoint: import.meta.env.VITE_BROADCASTING_URL,
        auth: {
          headers: {
            Authorization: 'Bearer ' + newToken
          }
        }
      })
      return true
    } catch (error) {
      return false
    }
  },

  // A customer's document page has no login: the document request's id is its credential, and the
  // backend's own broadcasting/auth turns that header into the person for the handshake.
  useDocumentMachineAuth(machineId) {
    try {
      configureEcho({
        broadcaster: 'reverb',
        key: import.meta.env.VITE_REVERB_APP_KEY,
        wsHost: import.meta.env.VITE_REVERB_HOST,
        wsPort: import.meta.env.VITE_REVERB_PORT,
        wssPort: import.meta.env.VITE_REVERB_PORT,
        forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
        authEndpoint: import.meta.env.VITE_BROADCASTING_URL,
        auth: {
          headers: {
            'X-Document-Machine': machineId
          }
        }
      })
      return true
    } catch (error) {
      return false
    }
  },

  clearToken() {
    try {
      const echoInstance = echo()

      if (echoInstance && echoInstance.connector && echoInstance.connector.options) {
        // Headers'dan Authorization'ı kaldır
        delete echoInstance.connector.options.auth.headers.Authorization

        echoInstance.disconnect()
      }
    } catch (error) {}
  }
}

EchoManager.initialize()
